<template>
    <section class="content content--cabinet">
        <div class="small-window">
            <form class="form-wrap">
                <h1 class="form-wrap__title">Восстановление пароля</h1>
                <div class="form-wrap__row">
                    <c-input
                            :label="'Телефон или Email'"
                            :fieldName="'phoneOrEmail'"
                            :type="'text'"
                            v-model="phoneOrEmail"
                            :validation="'required|phoneOrEmail'"
                            :externalStatus="phoneOrEmailExternalStatus"
                    ></c-input>
                </div>
                <div class="form-wrap__row" v-if="!showSmsCode">
                    <div class="button-wrap">
                        <button class="button button--form button--yellow" v-on:click.prevent="submit">Восстановить пароль</button>
                    </div>
                </div>

                <div class="form-wrap__row" v-if="showSmsCode && !showNewPassword">
                    <p class="form-wrap__row-title">Подтверждение <br> мобильного телефона</p>
                    <c-input-sms-code
                            :type="'tel'"
                            :fieldName="'smsCode'"
                            :mask="'# # # #'"
                            :label="'Код из СМС'"
                            v-model="smsCode"

                            :externalStatus="smsCodeExternalStatus"
                            :sendFunction="sendSmsCode"
                    >
                    </c-input-sms-code>
                    <div class="form-wrap__sms-timer">
                        <span class="form-wrap__timer-text" v-if="showTimer">Отправить код повторно</span>
                        <span class="form-wrap__timer-cloak" v-if="showTimer">{{timerText}}</span>
                        <span class="form-wrap__timer-link" v-on:click="repeatTimer" v-if="!showTimer">Отправить код повторно</span>
                    </div>
                </div>

                <div class="form-wrap__row" v-if="showNewPassword">
                    <c-input-password
                            :label="'Создайте пароль'"
                            :type="'password'"
                            :fieldName="'password'"
                            v-model="password"
                    >
                        <template slot="hint">
                            Пароль должен содержать не менее 8 символов
                        </template>
                    </c-input-password>
                </div>
                <div class="form-wrap__row" v-if="showNewPassword">
                    <c-input-password
                            :label="'Повторите пароль'"
                            :type="'password'"
                            :fieldName="'repeatPassword'"
                            v-model="passwordRepeat"

                    >
                        <template slot="hint">
                            Пароль должен содержать не менее 8 символов
                        </template>
                    </c-input-password>
                </div>

                <div class="form-wrap__row" v-if="passwordConfirm">
                    <div class="button-wrap">
                        <button class="button button--form button--yellow" v-on:click.prevent="updatePassword">Сменить пароль</button>
                    </div>
                </div>
            </form>
        </div>
    </section>
</template>

<script>
    import {TOGGLE_LOADER} from "../../../storage/mutations";
    import querystring from "querystring";
    import {STATUSES} from "../../../components/statuses";

    const TIMER = 60;
    export default {
        name: "forgotPassword",
        metaInfo: {
            title: 'Восстановление пароля'
        },
        data() {
            return {
                phoneOrEmail: '',
                phoneOrEmailExternalStatus: STATUSES.EMPTY,
                smsCode: '',
                smsCodeExternalStatus: STATUSES.EMPTY,

                showTimer: true,
                timer: TIMER,
                timerObject: '',
                timerText : 'Через '+TIMER+' сек',

                showSmsCode: false,



                password: '',
                passwordExternalStatus: STATUSES.EMPTY,
                passwordRepeat: '',
                passwordRepeatExternalStatus: STATUSES.EMPTY,

            }
        },
        watch: {
            timer: function (oldVal, newVal) {
                this.timerText = 'Через '+newVal+' сек';
                if (newVal === 10 ){
                    this.showPhoneTooltip = true;
                }

                if(newVal === 0){
                    this.timer = TIMER;
                    this.showTimer = false;
                    clearInterval(this.timerObject);
                }

            },
            smsCodeExternalStatus: function (oldVal, newVal) {
                let _this = this;
                this.errors.clear();
                // HACK  -FIX IT PLS
                setTimeout(function () {
                    _this.errors.clear();
                }, 200)
            }
        },
        methods: {
            submit: function () {
                let _this = this;
                let data = new FormData();
                this.$validator.validateAll().then(
                    (result) => {
                        if(result) {
                            if (_this.phoneOrEmail[0] === '8') {
                                _this.phoneOrEmail = '7' + _this.phoneOrEmail.substr(1);
                            }
                            if (_this.phoneOrEmail[0] === '+') {
                                _this.phoneOrEmail = _this.phoneOrEmail.substr(1);
                            }
                            data.append('username', _this.phoneOrEmail);

                            this.$http.post('/json/profile/user/password/restore', data).then(
                                (response) => {
                                    switch (response.data.code) {
                                        case 0: {
                                            _this.timerObject = setInterval(_ => {
                                                _this.timer -= 1;
                                            }, 1000);
                                            _this.showSmsCode = true;
                                            _this.phoneOrEmailExternalStatus = STATUSES.COMPLETE;
                                            break;
                                        }
                                        case 100: {
                                            _this.$validator.errors.add(
                                                'phoneOrEmail',
                                                'Поле не может быть пустым'
                                            );
                                            break;
                                        }
                                        case 200: {
                                            break;
                                        }
                                        case 500: {
                                            break;
                                        }
                                    }
                                },
                                (response) => {
                                },
                            );
                        }

                });

            },
            sendSmsCode: function () {
                let _this = this;
                let data = new FormData();
                data.append('code', _this.smsCode.replace(/[^0-9.]/g, ""));
                this.$http.post('/json/profile/password/restore/confirmation', data).then(
                    response => {
                        _this.smsCodeExternalStatus = STATUSES.LOAD;

                        if(response.data.code === 0){
                            _this.smsCodeExternalStatus = STATUSES.COMPLETE;
                            _this.phoneOrEmailExternalStatus = STATUSES.APPROVE;
                            clearInterval(this.timerObject);
                            _this.timer = TIMER;
                        }
                    },
                    response => {
                    }
                );
            },
            updatePassword: function(){
                let _this = this;
                let data = new FormData();
                data.append('password', _this.password);
                this.$http.post('/json/profile/password', data).then(
                    (response) => {
                      if(response.data.code === 0){
                          _this.$router.push({name: 'CabinetIndex'})
                      }  else{
                      }
                    },
                    (response) => {}
                ).catch(error => {

                })
            },

            repeatTimer: function () {
                this.timerText = 'Через '+this.timer+' сек';
                this.showTimer = true;
                this.timerObject = setInterval(_ => {
                    this.timer -= 1;
                }, 1000);
            },
        },
        computed: {
            isEmail: function () {
               return this.phoneOrEmail.indexOf('@') > -1;
            },
            showButton : function () {
                return this.phoneOrEmail.length > 0 && this.errors.length > 0;
            },
            
            showNewPassword: function () {
                return this.smsCodeExternalStatus === STATUSES.COMPLETE;
            },

            passwordConfirm: function () {
                return  (this.password.length >= 8) && (this.password === this.passwordRepeat);
            }
            
        },
        mounted() {
            let _this = this;
            _this.timerObject = setInterval(_ => {
                _this.timer -= 1;
            }, 1000)
        }
    };
</script>

<style lang="scss">
    @import "~@/assets/scss/variable";

    @import "~@/assets/scss/cabinet/desktop/form-wrap";
    @import "~@/assets/scss/cabinet/mobile/form-wrap";
    .content.content--cabinet {
        display: flex;
    }

    .small-window {
        max-width: 768px;
        width: 100%;
        flex: 1;
        margin: 0 auto;
        border-radius: 15px;
        background: $white;
    }

    @media screen and (max-width: 1024px) {
        .small-window {
            margin: 35px auto 0;
        }
    }
    @media screen and (max-width: 780px){
        .small-window{
            border-radius: 0;
            margin: 0;
            max-width: 100%;
            width: 100%;
        }
    }
</style>
